import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies, CookiesProvider } from 'react-cookie';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

const MODEL_LIST = ({deleteThisModel, editThisModel, getUserModels, userModels, searchTerm, clearSearch}) => {
	

  const [selectedIds, setSelectedIds] = useState([]);
  const lastCheckedIndex = useRef(null);

  const handleCheckboxChange = (index, id, event) => {
      if (event.shiftKey && lastCheckedIndex.current !== null && userModels) {
          const start = Math.min(lastCheckedIndex.current, index);
          const end = Math.max(lastCheckedIndex.current, index);
          const rangeIds = userModels.slice(start, end + 1).map(m => m._id);
          setSelectedIds(prev => {
              const combined = new Set([...prev, ...rangeIds]);
              return [...combined];
          });
      } else {
          setSelectedIds(prev =>
              prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
          );
      }
      lastCheckedIndex.current = index;
  };

  const handleBulkDelete = async () => {
      try {
          // Fire off deletion for every selected model
          for (let id of selectedIds) {
             await axios.post(`${process.env.REACT_APP_WEB_URL}api/models/delete-one-model`, { id }, {withCredentials:true});
          }
          toast.success("Selected models deleted successfully", { position:"top-right" });
          setSelectedIds([]);
          getUserModels();
      } catch (err) {
          toast.error("Failed to delete some models.", { position:"top-right" });
      }
  };

  const handleSuccess = (message) =>
    toast.success(message, {
      position:"top-right"
    })
  const handleError = (error) =>
    toast.error(error, {
      position:"top-right"
    })

	return (
		<>
			<div className="model-list-header">
                <div></div>
                <div>Model</div>
                <div>List</div>
                <div>Status</div>
                <div></div>
            </div>
			<div id="model-list">
				{(!userModels || userModels.length === 0) ? (
					searchTerm && searchTerm.length > 0 ? (
						<div style={{ padding: '2rem', textAlign: 'center' }}>
							<p>No results found.</p>
							<button className="btn-outline pill" onClick={clearSearch}>Clear search</button>
						</div>
					) : null
				) : (
		        userModels.map((model, index) => (
		          <div className="model-list-row" key={model._id}>
                    <div className="model-checkbox-col">
                        <input type="checkbox" checked={selectedIds.includes(model._id)} onClick={(e) => handleCheckboxChange(index, model._id, e)} readOnly className="custom-checkbox" />
                    </div>
                    <div className="model-name-col">
		                {model.name}
                    </div>
                    <div className="model-list-col">
                        {model.list ? (typeof model.list === 'string' ? model.list : (model.list.name || 'Unnamed List')) : 'Default List'}
                    </div>
                    <div className="model-status-col">
                        <div className={`btn-status status-${model.status}`}>
		                    {model.status === 'complete' && 'Complete 100%'}
                            {model.status === 'in-progress' && 'Built But Unpainted'}
                            {model.status === 'not-started' && 'Owned But Not Built'}
                            {model.status === 'not-owned' && 'Not Owned'}
                            {!['complete','in-progress','not-started','not-owned'].includes(model.status) && model.status}
                        </div>
                    </div>
                    <div className="model-actions-col">
                        <button className="btn-outline pill" onClick={() => editThisModel(model)} style={{ padding: '0.4rem 1rem', fontSize: '13px' }}>Edit Model</button>
                    </div>
		          </div>
		        ))
				)}
			</div>
            {selectedIds.length > 0 && (
                <div style={{ padding: '1.5rem 0', textAlign: 'center' }}>
                    <button className="btn-solid-gray pill" style={{ background: '#cc4125', color: 'white' }} onClick={handleBulkDelete}>Delete Model(s) ({selectedIds.length})</button>
                </div>
            )}
		</>
	);
};

export default MODEL_LIST
